import React, { useState } from "react";
import api from "../api/axios";

function InvitarUsuarioModal({ salaId, onClose }) {
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState(null);

  // POST corregido a la API con URL absoluta
  const handleInvitar = async () => {
    try {
      await api.post(`/salas/${salaId}/invitar`, { email });
      setMensaje("¡Invitación enviada!");
    } catch (e) {
      setMensaje("Error: " + (e.response?.data?.detail || "al invitar"));
    }
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow-xl flex flex-col gap-2 z-50 absolute top-16 left-1/2 -translate-x-1/2">
      <h2 className="text-lg font-bold mb-2">Invitar usuario a la sala</h2>
      <input
        type="email"
        placeholder="Email del usuario"
        className="border p-2 rounded"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <button
        onClick={handleInvitar}
        className="bg-blue-500 text-white rounded p-2 mt-2"
      >Invitar</button>
      {mensaje && <div className="text-sm mt-2">{mensaje}</div>}
      <button onClick={onClose} className="text-xs mt-4 underline text-gray-500">Cerrar</button>
    </div>
  );
}

export default InvitarUsuarioModal;
